/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Header_My_WaipuInputs */

const de_commons_header_my_waipu = /** @type {(inputs: Commons_Header_My_WaipuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein waipu.tv`)
};

/** @type {(inputs: Commons_Header_My_WaipuInputs) => LocalizedString} */
const en_commons_header_my_waipu = de_commons_header_my_waipu;

/**

* @param {Commons_Header_My_WaipuInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_header_my_waipu = /** @type {((inputs?: Commons_Header_My_WaipuInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Header_My_WaipuInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_header_my_waipu(inputs)
	return en_commons_header_my_waipu(inputs)
});